/**
 * Название изучаемого языка для подстановки в тексты (см. `useLanguageForms`):
 * {{nom}} — «Зачем тебе {{nom}}?», {{gen}} — «уровень {{gen}}», {{adv}} —
 * «говорить {{adv}}». В русском формы реальные, в остальных языках все три
 * формы — просто название: тексты новых локалей построены так, чтобы с ним
 * читались («niveau de {{gen}}», «parler {{adv}}», «{{adv}} sprechen»).
 */
export default {
  en: {
    en: { nom: 'English', gen: 'English', adv: 'English' },
    de: { nom: 'German', gen: 'German', adv: 'German' },
    pt: { nom: 'Portuguese', gen: 'Portuguese', adv: 'Portuguese' },
  },
  ru: {
    en: { nom: 'английский', gen: 'английского', adv: 'по-английски' },
    de: { nom: 'немецкий', gen: 'немецкого', adv: 'по-немецки' },
    pt: { nom: 'португальский', gen: 'португальского', adv: 'по-португальски' },
  },
  de: {
    en: { nom: 'Englisch', gen: 'Englisch', adv: 'Englisch' },
    de: { nom: 'Deutsch', gen: 'Deutsch', adv: 'Deutsch' },
    pt: { nom: 'Portugiesisch', gen: 'Portugiesisch', adv: 'Portugiesisch' },
  },
  pt: {
    en: { nom: 'inglês', gen: 'inglês', adv: 'inglês' },
    de: { nom: 'alemão', gen: 'alemão', adv: 'alemão' },
    pt: { nom: 'português', gen: 'português', adv: 'português' },
  },
  fr: {
    en: { nom: 'anglais', gen: 'anglais', adv: 'anglais' },
    de: { nom: 'allemand', gen: 'allemand', adv: 'allemand' },
    pt: { nom: 'portugais', gen: 'portugais', adv: 'portugais' },
  },
  es: {
    en: { nom: 'inglés', gen: 'inglés', adv: 'inglés' },
    de: { nom: 'alemán', gen: 'alemán', adv: 'alemán' },
    pt: { nom: 'portugués', gen: 'portugués', adv: 'portugués' },
  },
};
